/**
 * Maps raw gateway payment statuses to merchant-friendly labels.
 * Keep accessors/filters on the raw values — this mapping is display-only.
 */
const STATUS_LABELS = {
  AUTHORIZED: "Approved",
  COMPLETED: "Approved",
  CAPTURED: "Approved",
  SETTLED: "Approved",
  SETTLEMENT_INITIATED: "Approved",
  FAILED: "Declined",
  VOID_UNSUCCESSFULL: "Declined",
  VOID_UNSUCCESSFUL: "Declined",
  INITIATED: "Pending",
  VOID: "Voided",
  REFUNDED: "Refunded",
};

const STATUS_COLORS = {
  Approved: "success",
  Declined: "error",
  Pending: "warning",
  Voided: "secondary",
  Refunded: "info",
};

export const mapTransactionStatus = (status) => {
  if (!status) return "—";
  return STATUS_LABELS[String(status).toUpperCase()] ?? status;
};

export const transactionStatusColor = (status) =>
  STATUS_COLORS[mapTransactionStatus(status)] ?? "dark";

export default mapTransactionStatus;
